import { Datagrid, DateField, List, TextField } from 'react-admin';
import { AppGlobalAlertsCommandPanel } from './AppGlobalAlertsCommandPanel';

export const AppGlobalAlertsList = () => (
  <List resource="appGlobalAlerts">
    <Datagrid
      bulkActionButtons={false}
      expand={AppGlobalAlertsCommandPanel}
    >
      <TextField source="id" />
      <TextField source="title" />
      <DateField source="createdAt" showTime />
      <DateField source="archivedAt" showTime />
    </Datagrid>
  </List>
);
